var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ik-data-table',{attrs:{"entity-name":_vm.$t('openTime'),"icon":'mdi-calendar-clock',"model":_vm.model}})
}
var staticRenderFns = []

export { render, staticRenderFns }